// extracted by mini-css-extract-plugin
export default {"root":"UnifiedMatrix_root__IdP6E","header":"UnifiedMatrix_header__+mdLs","body":"UnifiedMatrix_body__eLRVs"};